import React from "react";
import styled from "styled-components";

interface Props<T> {
  value: T;
  options: T[];
  onChange: (value: T) => void;
}

export function Select<T extends string>({
  value,
  options,
  onChange,
}: Props<T>) {
  return (
    <StyledSelect
      className="select-field"
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </StyledSelect>
  );
}

const StyledSelect = styled.select`
  width: 100%;
  padding: 12px;
  color: ${(props) => props.theme?.colors?.text};
  font-weight: bold;
  border-radius: 5px;
  border-color: #c7c7cd;
  appearance: none;
  background: url(data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OCIgZmlsbD0iI0REMDAzMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTQuODMgMTYuNDJsOS4xNyA5LjE3IDkuMTctOS4xNyAyLjgzIDIuODMtMTIgMTItMTItMTJ6Ii8+CiAgPHBhdGggZD0iTTAtLjc1aDQ4djQ4aC00OHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+)
    no-repeat 100% 50%;

  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
